import script from "./DetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailView.vue?vue&type=script&setup=true&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=da34b99e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da34b99e"]])

export default __exports__